module.exports = __webpack_public_path__ + "img/bathroom.0db4f55.svg";